import React from 'react';
import Pagination from '../pagination/pagination.tsx';
import EmptyState from '../emptyState/emptyState.tsx';

interface ReusableTableProps {
  headers: string[];
  rows: any[];
  dataCount: number;
  currentPage: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
  renderRow: (item: any, index: number) => React.ReactNode;
}

const ReusableTable: React.FC<ReusableTableProps> = ({
  headers,
  rows,
  dataCount,
  currentPage,
  itemsPerPage,
  onPageChange,
  renderRow,
}) => {
  return (
    <div className="table_data_grid">
      <div className="default-table">
        <div className="table_scroll">
          <table className="data-table align-middle">
            <thead>
              <tr>
                {headers.map((header, index) => (
                  <th
                    key={index}
                    className={`table_header_text${
                      index === headers.length - 1 ? ' table_header_text--actions' : ''
                    }`}
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {dataCount > 0 ? (
                rows.map((item, index) => renderRow(item, index))
              ) : (
                <tr>
                  <td colSpan={headers.length}>
                    <EmptyState
                      icon="ticket"
                      title="No data available"
                      subtitle="Records will appear here once available"
                    />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {(dataCount > 0 || currentPage > 1) && (
        <Pagination
          itemsPerPage={itemsPerPage}
          count={dataCount}
          currentPage={currentPage}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
};

export default ReusableTable;
